export const ADD_ORGANIZATION_MODAL_ID = 'add_organization_modal';

/**
 * @deprecated Use DialogService.open(ADD_ORGANIZATION_MODAL_ID) instead
 */
export const showAddOrganizationModal = () => {
  const element = document.getElementById(ADD_ORGANIZATION_MODAL_ID) as HTMLDialogElement;
  element?.showModal();
};

/**
 * @deprecated Use DialogService.close(ADD_ORGANIZATION_MODAL_ID) instead
 */
export const closeAddOrganizationModal = () => {
  const element = document.getElementById(ADD_ORGANIZATION_MODAL_ID) as HTMLDialogElement;
  element?.close();
};

export const DELETE_ORGANIZATION_MODAL_ID = 'deleteOrganizationModal';

/**
 * @deprecated Use DialogService.open(DELETE_ORGANIZATION_MODAL_ID) instead
 */
export const showDeleteOrganizationModal = () => {
  const element = document.getElementById(DELETE_ORGANIZATION_MODAL_ID) as HTMLDialogElement;
  element?.showModal();
};

/**
 * @deprecated Use DialogService.close(DELETE_ORGANIZATION_MODAL_ID) instead
 */
export const closeDeleteOrganizationModal = () => {
  const element = document.getElementById(DELETE_ORGANIZATION_MODAL_ID) as HTMLDialogElement;
  element?.close();
};

export const CONFIGURE_GUIDELINES_MODAL_ID = 'configure_guidelines_modal';

export const DELETE_ORGANIZATION_WARNING_MODAL_ID = 'deleteOrganizationWarningModal';

/**
 * @deprecated Use DialogService.open(DELETE_ORGANIZATION_WARNING_MODAL_ID) instead
 */
export const showDeleteOrganizationWarningModal = () => {
  const element = document.getElementById(DELETE_ORGANIZATION_WARNING_MODAL_ID) as HTMLDialogElement;
  element?.showModal();
};

/**
 * @deprecated Use DialogService.close(DELETE_ORGANIZATION_WARNING_MODAL_ID) instead
 */
export const closeDeleteOrganizationWarningModal = () => {
  const element = document.getElementById(DELETE_ORGANIZATION_WARNING_MODAL_ID) as HTMLDialogElement;
  element?.close();
};

